//Most of the lines are commented out because they can be used only if the composite device is a feed, just like basic devices.
import React, { useEffect, useState } from "react";
import ErrorBoundary from "../../ErrorBoundary";
import SummaryWidget from "../Widgets/Summary/SummaryWidget";
import LayoutControls from "../Widgets/LayoutControls/LayoutControls";
import PropTypes from "prop-types";
import { Translate, getTranslation } from "orion-components/i18n";
import { facilityService } from "client-app-core";
import $ from "jquery";
// import PinToDialog from "../../SharedComponents/PinToDialog";
import CompositeDeviceEditDialog from "./components/CompositeDeviceEditDialog";
import CompositeDeviceAccessControlWidget from "../Widgets/AccessControl/CompositeDeviceAccessControlWidget";
import { CamerasWidget, FileWidget, MapWidget } from "../Widgets";
import { useSelector, useDispatch } from "react-redux";
import { selectedContextSelector } from "orion-components/ContextPanel/Selectors";
import { getDir } from "orion-components/i18n/Config/selector";
//actions
import { openDialog, closeDialog } from "orion-components/AppState/Actions";

import {
	// addRemoveFromCollections,
	// addRemoveFromEvents,
	// createCollection,
	updateDevice
} from "orion-components/SharedActions/deviceProfileActions";
import { canManageByApplication } from "orion-components/Profiles/Selectors";
import { compositeDeviceWidgetConfig } from "orion-components/Profiles/Selectors/CompositeDeviceProfileSelectors";
import isEqual from "lodash/isEqual";
import { startAttachmentStream } from "orion-components/ContextualData/Actions";
import { unlinkEntities } from "../../SharedActions/entityProfileActions";
import { startCamerasInRangeStream, unsubscribeFromFeed } from "../../ContextualData/Actions";

const propTypes = {
	facilityOption: PropTypes.bool,
	appData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	selectWidget: PropTypes.func,
	floorPlansWithFacFeed: PropTypes.bool,
	selectFloorPlanOn: PropTypes.func,
	forReplay: PropTypes.bool,
	readOnly: PropTypes.bool,
	widgetsExpandable: PropTypes.bool,
	view: PropTypes.string,
	endDate: PropTypes.date,
	disableEdit: PropTypes.bool
};

const defaultProps = {
	selectFloorPlanOn: () => {},
	//The `readonly` and `forReplay` props are exclusively provided to this component by the `replay-app`. To ensure the proper functionality of other apps, it is necessary to set both `readonly` and `forReplay` to `false`.
	readOnly: false,
	forReplay: false,
	disableEdit: false
};

const CompositeDeviceProfile = ({
	facilityOption,
	// appData,
	selectWidget,
	floorPlansWithFacFeed,
	selectFloorPlanOn,
	widgetsExpandable,
	forReplay,
	readOnly,
	enableActionIcon,
	disableEdit
	// endDate
}) => {
	const dispatch = useDispatch();

	const context = useSelector(state => selectedContextSelector(state));
	const { entity, camerasInRange } = context ?? {};
	const view = useSelector(state => entity && state.userAppState?.cameraView);

	const entityType = entity?.entityType;
	const contextId = entity?.id;
	const dir = useSelector(state => getDir(state) || null);

	const compositeDevice = entity;
	const { entityData } = compositeDevice ?? {};
	const { geometry } = entityData ?? {};
	const { name, description } = compositeDevice ?? {};

	const floorPlansWithFacilityFeed = useSelector(state =>
		floorPlansWithFacFeed ? state.globalData.floorPlanWithFacilityFeedId.floorPlans : null
	);

	const [scrolledUp, setScrolledUp] = useState(false);
	// const [hiding, setHiding] = useState(false);
	const [layoutControlsOpen, setLayoutControlsOpen] = useState(false);
	const [facilityHidden, setFacilityHidden] = useState(true);

	const canManageDevice = useSelector(state => canManageByApplication(state, "cameras-app", "manage"));

	// const canManageEvents = useSelector((state) => canManageByApplication(state, "events-app", "manage"));
	// const canPinToCollections = useSelector((state) => canManageByApplication(state, "map-app", "manage"));
	const widgetState = useSelector(state => (entity ? compositeDeviceWidgetConfig(state) : []), isEqual);
	const accessControlWidget = widgetState?.find(widget => widget.id === "access_control");
	const selectedTab = useSelector(state => state?.appManager?.listPanel?.selectedTab);

	useEffect(() => {
		if (!forReplay) {
			if (getWidgetStatus("files")) dispatch(startAttachmentStream(contextId, "profile"));

			if (
				compositeDevice?.entityData?.displayTargetId &&
				compositeDevice?.entityData?.displayType?.toLowerCase() === "facility"
			) {
				facilityService.getFloorPlan(compositeDevice.entityData.displayTargetId, (err, res) => {
					if (err) {
						setFacilityHidden(true);
					} else if (res.success) {
						setFacilityHidden(false);
					}
				});
			}
		}

		return () => {
			if (typeof selectWidget === "function") {
				dispatch(selectWidget("map-view"));
			}
		};
	}, [selectWidget]);

	useEffect(() => {
		handleScroll();
	}, [scrolledUp]);

	useEffect(() => {
		if (!forReplay && widgetState?.length > 0) {
			const retryCamera = widgetState.find(element => element.id === "cameras");
			const { camerasInRange } = context;
			if (retryCamera.enabled && !camerasInRange) {
				dispatch(startCamerasInRangeStream(contextId, entityType, "profile"));
			}
		}
	}, [widgetState, forReplay]);

	const getWidgetStatus = widgetId => {
		const widgetConfig = widgetState;
		const widget = widgetConfig.find((widget, index) => {
			widget.index = index;
			return widget.id === widgetId;
		});

		return widget;
	};

	const handleScroll = () => {
		$(".cb-profile-wrapper").on("resize scroll", () => {
			const elementTop = $(".summary-wrapper").offset().top;
			const elementBottom = elementTop + $(".summary-wrapper").outerHeight() + 120; // offset for app/navigation bar
			const viewportTop = $(".cb-profile-wrapper").scrollTop();
			const profileHeight = $(".cb-profile-wrapper").height();
			const viewportBottom = viewportTop + $(".cb-profile-wrapper").height();
			const widgetsHeight = $(".widgets-container").height();
			const scrollLength = viewportBottom - elementBottom;
			const pctScrolled = Math.floor((viewportTop / scrollLength) * 100); // gets percentage scrolled

			if (!scrolledUp && pctScrolled > 1 && widgetsHeight > profileHeight - 66) {
				setScrolledUp(true);
			} else if (scrolledUp && pctScrolled < 2) {
				setScrolledUp(false);
			}
		});
	};

	const handleExpand = () => {
		setScrolledUp(false);
		$(".cb-profile-wrapper").scrollTop(0);
	};

	const handleEditLayout = event => {
		event.preventDefault();
		setLayoutControlsOpen(true);
	};

	const handleCloseEditLayout = () => {
		setLayoutControlsOpen(false);
	};

	const showFloorPlanOnTargetClick = () => {
		const { entityData } = compositeDevice;
		if (entityData.displayType === "facility" && floorPlansWithFacilityFeed !== null) {
			const floorPlanData = floorPlansWithFacilityFeed[entityData.displayTargetId];
			if (floorPlanData.id === entityData.displayTargetId) {
				selectFloorPlanOn(floorPlanData, floorPlanData.facilityFeedId);
			}
		}
	};

	const getSummaryWidgetActions = () => {
		let actions = [];
		if (
			entityData?.displayType?.toLowerCase() === "facility" &&
			entityData?.displayTargetId &&
			facilityOption &&
			!facilityHidden
		) {
			actions.push({
				name: getTranslation("global.profiles.compositeDeviceProfile.facility"),
				nameText: "Facility",
				action: () => window.location.replace(`/facilities-app/#/?${entityData.displayTargetId}`)
			});
		}
		// actions = [
		// 	...actions,
		// 	{
		// 		name: getTranslation("global.profiles.deviceProfile.pinTo"),
		// 		nameText: "Pin To",
		// 		action: () => dispatch(openDialog("pinToDialog"))
		// 	}
		// ];

		if (canManageDevice && !disableEdit) {
			actions = [
				...actions,
				{
					name: getTranslation("global.profiles.compositeDeviceProfile.edit"),
					nameText: "Edit",
					action: () => dispatch(openDialog("compositeDeviceEditDialog"))
				}
			];
		}
		return actions;
	};

	const widgetRenderFilters = {
		access_control: false,
		map: selectedTab === "deviceConfiguration" ? true : !widgetsExpandable,
		// activities: !(context?.activities || forReplay),
		// linked_items: disableLinkedItems,
		cameras: !camerasInRange,
		files: !context?.attachments
	};

	const renderWidgets = widgetName => {
		switch (widgetName) {
			case "map":
				return <MapWidget id={widgetName} selectWidget={selectWidget} entityType={entityType} />;
			case "access_control":
				return (
					<CompositeDeviceAccessControlWidget
						id={widgetName}
						key={`${contextId}-access_control`}
						contextId={contextId}
						enabled={accessControlWidget?.enabled}
						selectWidget={selectWidget}
						selected={view === widgetName}
						enableActionIcon={enableActionIcon}
						widgetsExpandable={widgetsExpandable}
						readOnly={readOnly}
					/>
				);
			case "files":
				return (
					<FileWidget
						id={widgetName}
						key={`${contextId}-files`}
						canDelete={!readOnly && canManageDevice}
						hasAccess={true}
						selected={view === widgetName}
						selectWidget={selectWidget}
						contextId={contextId}
						subscriberRef="profile"
						widgetsExpandable={widgetsExpandable}
					/>
				);
			case "cameras":
				return (
					<CamerasWidget
						id={widgetName}
						key={`${contextId}-cameras`}
						canLink={!readOnly && canManageDevice}
						unlinkCameras={unlinkEntities}
						contextId={contextId}
						unsubscribeFromFeed={unsubscribeFromFeed}
						subscriberRef="profile"
						readOnly={readOnly}
						disableSlew={readOnly}
						selectFloorPlanOn={selectFloorPlanOn}
						floorPlansWithFacilityFeed={floorPlansWithFacilityFeed}
					/>
				);

			default:
				return null;
		}
	};

	if (context) {
		// Height of summary-info (consistent between scrolled and not scrolled state) + padding
		const scrollOffset = scrolledUp ? 167 : 0;
		// Dynamic offset for widget container when SummaryWidget is collapsed
		const widgetsContainerStyle = {
			top: scrollOffset
		};

		return (
			<div className="cb-profile-wrapper" style={{ height: "100%" }}>
				<div style={{ display: layoutControlsOpen ? "block" : "none" }}>
					<ErrorBoundary>
						<LayoutControls
							close={handleCloseEditLayout}
							widgetOrder={widgetState}
							profile="compositeDevice"
							layoutControlsOpen={layoutControlsOpen}
						/>
					</ErrorBoundary>
				</div>
				<div style={{ display: layoutControlsOpen ? "none" : "block" }}>
					<ErrorBoundary>
						<SummaryWidget
							id={contextId}
							readOnly={readOnly}
							contextId={contextId}
							name={name}
							type="compositeDevice"
							geometry={geometry}
							description={description}
							scrolledUp={scrolledUp}
							handleExpand={handleExpand}
							selectFloor={showFloorPlanOnTargetClick}
							actions={getSummaryWidgetActions()}
							displayType="Composite Device"
						/>
					</ErrorBoundary>
					{!scrolledUp && (
						<div className="layout-control-button">
							<a className="cb-font-link" onClick={handleEditLayout}>
								<Translate value="global.profiles.compositeDeviceProfile.editProfileLayout" />
							</a>
						</div>
					)}
					<div className="widgets-container" style={widgetsContainerStyle}>
						{widgetState
							.filter(element => getWidgetStatus(element.id))
							.map(element => {
								const { id, enabled } = element;
								if (widgetRenderFilters[id]) {
									return false;
								}
								if (!enabled) {
									return false;
								}
								return <ErrorBoundary key={id}>{renderWidgets(id)}</ErrorBoundary>;
							})}

						<CompositeDeviceEditDialog
							compositeDevice={compositeDevice}
							entityType={entityType}
							close={() => dispatch(closeDialog("compositeDeviceEditDialog"))}
							update={(deviceId, entityData) => dispatch(updateDevice(deviceId, entityData, true))}
							dir={dir}
						/>
						{/* Since the composite device is not a feed and the ecosystem requires feed authorization, pinning it to an event is not possible. I'm commenting it out for now. */}
						{/* <PinToDialog
							close={() => dispatch(closeDialog("pinToDialog"))}
							entity={compositeDevice}
							addRemoveFromCollections={addRemoveFromCollections}
							addRemoveFromEvents={addRemoveFromEvents}
							createCollection={createCollection}
							openDialog={openDialog}
							closeDialog={closeDialog}
							canManageEvents={canManageEvents}
							canPinToCollections={canPinToCollections}
							dir={dir}
						/> */}
					</div>
				</div>
			</div>
		);
	} else {
		return <div />;
	}
};

CompositeDeviceProfile.propTypes = propTypes;
CompositeDeviceProfile.defaultProps = defaultProps;
export default CompositeDeviceProfile;
